
define('text!modules/util/collection/collection_template.html',[],function () { return '<div class="js-actions"></div>\r\n<div class="js-collection-header"></div>\r\n<div class="js-collection-items"></div>\r\n<div class="js-pagination"></div>\r\n';});

